import { render, staticRenderFns } from "./BenefitOrderSummary.vue?vue&type=template&id=660f4e8c&scoped=true"
import script from "./BenefitOrderSummary.vue?vue&type=script&lang=js"
export * from "./BenefitOrderSummary.vue?vue&type=script&lang=js"
import style0 from "./BenefitOrderSummary.vue?vue&type=style&index=0&id=660f4e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660f4e8c",
  null
  
)

export default component.exports